import type { BillingAccountUsage } from "@warrenio/api-spec/spec.oats.gen";

export const billingAccountUsageExample: BillingAccountUsage[] = [
    {
        amount: 10.13208,
        id: -1,
        invoice_id: -1,
        is_technical: false,
        item_price: 0.048248,
        name: "test, 2 CPUs, 4 GB RAM",
        qty_unit: "h",
        qty: 210.0,
        vat_amount: 0,
    },
    {
        amount: 0.4914,
        id: -2,
        invoice_id: -1,
        is_technical: false,
        item_price: 0.0117,
        name: "test, 50 GB main storage",
        qty_unit: "h",
        qty: 42.0,
        vat_amount: 0,
    },
    {
        amount: 1.9539,
        id: -3,
        invoice_id: -1,
        is_technical: false,
        item_price: 0.0117,
        name: "test, 50 GB main storage",
        qty_unit: "h",
        qty: 167.0,
        vat_amount: 0,
    },
    {
        amount: 0.6027,
        id: -4,
        invoice_id: -1,
        is_technical: false,
        item_price: 0.00287,
        name: "Assigned floating IP 176.112.157.206",
        qty_unit: "h",
        qty: 210.0,
        vat_amount: 0,
    },
    {
        amount: 0.00274,
        id: -5,
        invoice_id: -1,
        is_technical: false,
        item_price: 0.00274,
        name: "Unassigned floating IP 176.112.157.214",
        qty_unit: "h",
        qty: 1.0,
        vat_amount: 0,
    },
    {
        amount: 0.6027,
        id: -6,
        invoice_id: -1,
        is_technical: false,
        item_price: 0.00287,
        name: "Assigned floating IP 176.112.157.214",
        qty_unit: "h",
        qty: 210.0,
        vat_amount: 0,
    },
    {
        amount: 2.00294,
        id: -7,
        invoice_id: -1,
        is_technical: false,
        item_price: 0.00274,
        name: "Unassigned floating IP 176.112.150.212",
        qty_unit: "h",
        qty: 731.0,
        vat_amount: 0,
    },
    {
        amount: 0.18,
        id: -8,
        invoice_id: -1,
        is_technical: false,
        item_price: 0.015,
        name: "Load balancer loader",
        qty_unit: "h",
        qty: 12.0,
        vat_amount: 0,
    },
    {
        amount: 15.250068,
        id: -9,
        invoice_id: -1,
        is_technical: false,
        item_price: 0.068694,
        name: "PostgreSQL node, 2 CPUs, 1 GB RAM",
        qty_unit: "h",
        qty: 222.0,
        vat_amount: 0,
    },
    {
        amount: 15.250068,
        id: -10,
        invoice_id: -1,
        is_technical: false,
        item_price: 0.068694,
        name: "PostgreSQL node, 2 CPUs, 1 GB RAM",
        qty_unit: "h",
        qty: 222.0,
        vat_amount: 0,
    },
    {
        amount: 3.11688,
        id: -11,
        invoice_id: -1,
        is_technical: false,
        item_price: 0.01404,
        name: "PostgreSQL storage, 20 GB",
        qty_unit: "h",
        qty: 222.0,
        vat_amount: 0,
    },
    {
        amount: 3.11688,
        id: -12,
        invoice_id: -1,
        is_technical: false,
        item_price: 0.01404,
        name: "PostgreSQL storage, 20 GB",
        qty_unit: "h",
        qty: 222.0,
        vat_amount: 0,
    },
];
